import React from 'react'
import { Collapse } from '@/components/frontend/atoms/content/Collapse'

interface FAQItemProps {
  question: string
  answer: string
  defaultOpen?: boolean
}

export const FAQItem: React.FC<FAQItemProps> = ({ question, answer, defaultOpen = false }) => (
  <Collapse title={question} defaultOpen={defaultOpen}>{answer}</Collapse>
)
